import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import './QRISPayment.css'
import FlipCountdown from '@rumess/react-flip-countdown';
import moment from 'moment';
import base64Sign from '../../function/base64Sign';
import encryptData from '../../function/encryptData';
import { BaseURL, headersWithToken, moneyFormat } from '../../function/helpers';
import { getToken } from '../../utils/setSessionUser';
import axios from 'axios';
import QRISIcon from '../../Asset/Icon/Checkout/QRIS_Logo.svg'
import { Collapse } from 'antd';
import ReactHtmlParser from 'react-html-parser';
const { Panel } = Collapse;

function QRISPayment() {

    const history  = useHistory();
    const location = useLocation();

    const [qrisDetail, setQrisDetail] = useState({});
    const [loading, setLoading] = useState(true);
    
    // console.log(location, 'location')
    // console.log(history, 'history')

    const formate = moment.unix(qrisDetail.expired_time).format("yyyy-MM-DD HH:mm:ss")

    async function QRISDetailAPI(id) {
        try{
            const signature = base64Sign("/checkout/InquiryQRIS"); 
            const dataParams = encryptData(`{"order_id":"${id}"}`)           
            const headers = headersWithToken(signature , getToken());
            const data = await axios.post(BaseURL + '/checkout/InquiryQRIS',{data: dataParams},{headers : headers});
            var datas = data.data.response_data.results;
            // console.log(datas, 'datas');
            if(data.status === 200){
                setQrisDetail(datas);
                if(datas.order_status_id === 4){
                    history.push(`/payment/finishpayment?order_id=${datas.order_code}&result=success`)
                }
                if(datas.order_status_id === 9){
                    history.push('/RiwayatPesananDetail/'+datas.order_id)
                }
            }
            setLoading(false);
            
        }catch(err){
            console.log(err);
        }
    }

    useEffect(() => {
        const orderId = location.state.order_id;
        QRISDetailAPI(orderId);
        const interval = setInterval(() => {
            QRISDetailAPI(orderId);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{top: 80}} className="main">
            <div>
                <p className="head-2" style={{textAlign: 'center', marginBottom: 'unset'}}>
                    <img src={QRISIcon} alt="QRISIcon" width={80} height={55}/>
                </p>
                <br/>
                <aside className="checkout-info">
                    <span>Total Belanja</span>
                    <span style={{float: 'right'}}>{moneyFormat(qrisDetail.amount)}</span>
                </aside>
            </div>
            <br/>
            <div className="va-detail-info">
                <aside style={{textAlign: 'center', marginTop: 20}}>
                    <img
                        src={qrisDetail.qr_url}
                        alt="qris"
                        style={{marginBottom: 10, width: 180, height: 180}}
                    />
                    {/* <p style={{fontSize: 10, marginTop: 30}} className="subtitle-1-va">
                        Kode Pembayaran ( Nomor Akun Virtual )
                    </p> */}
                    {/* <div className="va-number" id="vaNumber" onClick={() => 'copyVAnumber()'}>
                        <b>
                            {qrisDetail.transaction_code}
                        </b>
                    </div> */}
                    {/* <img src={'copy_icon'} className="copy_icon" alt="" /> */}
                    <p style={{fontSize: 10}}>
                        <b>
                            Jumlah transfer : {moneyFormat(qrisDetail.amount)}
                        </b>
                    </p>
                    <div className="div-hr" style={{width: '100%', marginBottom: 10}}>
                        <hr style={{backgroundColor: 'black', height: 1, width: '17%'}}></hr>
                    </div>
                    <p style={{fontSize: 10}} className="subtitle-1-va">Mohon lakukan pembayaran dalam waktu</p>
                    <FlipCountdown
                        endAt={formate}
                        size={'medium'}
                        hideMonth={true}
                        hideDay={true}
                        hideYear={true}
                        hourTitle=''
                        minuteTitle=''
                        secondTitle=''
                    />
                </aside>
            </div>
            <br/>
            <div className="panduan">
                <Collapse accordion>
                    <Panel header="Panduan Pembayaran" key="1">
                        <table style={{maxWidth: '380px !important', width: '100%'}}>
                            <tbody>
                                {
                                    qrisDetail.instruction_detail !== undefined &&
                                    qrisDetail.instruction_detail.map((item, index) => {
                                        return (
                                        <tr className="content-item-title">
                                            <td style={{verticalAlign: 'top'}}>{index + 1}.</td>
                                            <td style={{display: 'inline-block', overflowWrap: 'anywhere', paddingLeft: 5}}>{ReactHtmlParser(item)}</td>
                                        </tr>  
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </Panel>
                </Collapse>
            </div>
        </div>
    )
}

export default QRISPayment 
